/**
 * Banner am Vorgang (Einheit E, Antoine 26.10.2026): eine BEZAHLTE Zahlung hat keine versendete Rechnung. Je Zahlung
 * eine Zeile „Rechnung offen: <Art> <Betrag> – <Grund>“ (Grund aus dem Verlauf: `rechnung.nicht_erstellt` /
 * `rechnung.versand_fehlgeschlagen`, sonst ein ruhiger Satz) und der Knopf „Rechnung senden“. Reine Anzeige; gesendet
 * wird im Dialog (`RechnungSendenDialog`), Beträge stammen aus der Zahlung.
 */
import { Button, Icon } from "../components";
import { money, PAYMENT_TYPE_LABEL } from "../format";
import type { Payment } from "../types";
import { rechnungOffen, rechnungOffenGrund } from "../../lib/rechnung-offen";

interface VerlaufEintrag {
  action: string;
  details: Record<string, unknown> | null;
  createdAt: string;
}

export function RechnungOffenHinweis({
  payments,
  verlauf,
  onSenden,
  probelauf = false,
  istInhaber = true,
}: {
  payments: Payment[];
  verlauf: readonly VerlaufEintrag[];
  onSenden: (p: Payment) => void;
  /** Probelauf-Vorgänge bekommen nie eine echte Rechnung: kein Banner. */
  probelauf?: boolean;
  /** Nur Inhaber dürfen Rechnungen senden. */
  istInhaber?: boolean;
}) {
  const offen = payments.filter((p) => rechnungOffen(p, verlauf));
  if (probelauf || !istInhaber || offen.length === 0) return null;
  return (
    <ul className="space-y-2" aria-label="Offene Rechnungen" data-testid="rechnung-offen">
      {offen.map((p) => (
        <li key={p.id} className="flex flex-col gap-2 rounded-lg bg-[#F0EAE0] px-2.5 py-2 sm:flex-row sm:items-center sm:justify-between dark:bg-white/[0.08]" data-testid={`rechnung-offen-${p.id}`}>
          <p className="flex min-w-0 items-start gap-1.5 font-body-sm text-[11.5px] text-[#6F675A]">
            <Icon name="receipt_long" className="mt-px shrink-0 text-[14px]" />
            <span className="min-w-0 break-words">
              <span className="font-semibold">
                Rechnung offen: {PAYMENT_TYPE_LABEL[p.paymentType] ?? "Zahlung"} · {money(p.amountCents)}
              </span>{" "}
              – {rechnungOffenGrund(p, verlauf)}
            </span>
          </p>
          <Button type="button" variant="secondary" className="!py-1.5 !text-[11.5px]" data-testid={`rechnung-offen-senden-${p.id}`} onClick={() => onSenden(p)}>
            <Icon name="forward_to_inbox" className="text-[15px]" /> Rechnung senden
          </Button>
        </li>
      ))}
    </ul>
  );
}
